var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInformationDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "778860E2-9AA4-4BDF-BEB4-F44B50BDA416") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Questionnaire",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Q-P1-US-ZIP-tooltip",
    transform: "translate(-796.000000, -480.000000)",
    fill: "#354354",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(589.000000, 270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reside",
    transform: "translate(0.000000, 186.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216,24 C211.037464,24 207,28.037464 207,33 C207,37.962536 211.037464,42 216,42 C220.962536,42 225,37.962536 225,33 C225,28.037464 220.962502,24 216,24 Z M216.585423,38.3399194 C216.157841,38.4112003 215.307037,38.5892308 214.874991,38.6250086 C214.509282,38.6552927 214.164174,38.445948 213.953799,38.1454421 C213.742875,37.8449706 213.692333,37.4604453 213.817555,37.1154747 L215.518785,32.4375129 L213.749983,32.4375129 C213.748472,31.4627572 214.479616,30.7460342 215.414748,30.4709711 C215.861009,30.3396714 216.692448,30.1599928 217.124974,30.18753 C217.384106,30.2040112 217.835792,30.3665906 218.046166,30.6670965 C218.25709,30.967568 218.307632,31.3520933 218.18241,31.6970639 L216.48118,36.3750258 L218.249433,36.3750258 C218.249777,37.3486483 217.545895,38.1798465 216.585423,38.3399194 L216.585423,38.3399194 Z M217.124974,29.6250086 C216.503636,29.6250086 215.999966,29.1212698 215.999966,28.5 C215.999966,27.8786615 216.503636,27.3749914 217.124974,27.3749914 C217.746313,27.3749914 218.249983,27.8786615 218.249983,28.5 C218.249983,29.1213041 217.746347,29.6250086 217.124974,29.6250086 Z",
    id: "icon-information-copy"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformationDark);
export default __webpack_public_path__ + "static/media/icon-information-dark.99d822c0f43e2cc4a2d4da6a13df6692.svg";
export { ForwardRef as ReactComponent };